import React, { useContext, useEffect } from 'react'
import { useState } from 'react';
import axios from "axios"
import { useNavigate } from 'react-router-dom';
import { UserContex } from '../context API/UserContext';
const AddService = () => {
    const [name, setName] = useState("");
    const [desc, setDesc] = useState("");
    const [image,setImage]=useState()
     const [userData, setUserData] = useContext(UserContex);
    const navigate=useNavigate()
    console.log(name)
    console.log(image)
    const handlesubmit=(e)=>{
e.preventDefault()
const formData= new FormData()
formData.append("name",name)
formData.append("desc",desc)
formData.append("image",image)
axios.post("https://back.waratechnology.com/api/service/setservice",formData)
.then((res)=>{
console.log(res.data.msg)
navigate("/")
})
.catch((err)=>{
    alert(err.response.data.msg);
console.log(err.data)
});
    }
    useEffect(() => {
      if (!userData.user) {
        navigate("/login");
      }
    });
  return (
    <div className="bg-gray-400  flex justify-center items-center h-screen pt-12 ">
      <div className="w-3/4 h-3/4 md:w-1/2 md:h-3/4 bg-white  border border-black-1 border-rounded rounded-2xl p-4 shadow-lg shadow-white-500/50 ">
        <div className="flex justify-center mt-2 mb-4">
          <h1 className="uppercase font-bold text-2xl">Add Service</h1>
        </div>
        <form
        onSubmit={handlesubmit}
        className=''
        >
          <div className="flex items-center justify-center mb-4">
            <label className="font-bold ">Name</label>
            <input
              placeholder="service name"
              type="text"
              className="w-full  pl-2 h-12 md:h-8 border border-gray-300 rounded-2xl"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="flex items-center justify-center mb-4">
            <label className=" font-bold">Description</label>
            <input
              placeholder="description"
              type="text"
              className="w-full h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setDesc(e.target.value)}
            />
          </div>
          <div className="flex items-center justify-center mb-4">
            <label className="font-bold">Image</label>
            <input
              placeholder="choose image"
              type="file"
              className="w-full h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setImage(e.target.files[0])}
            />
          </div>

          <div className="flex justify-center mt-4">
            <button
              type=""
              className="uppercase bg-red-500 mt-4 text-white px-4 py-1 rounded rounded-fully"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddService
